var map = {
	"./1.png": 223,
	"./2.png": 113,
	"./clients/client-bentara.jpg": 71,
	"./clients/client-egs.png": 72,
	"./clients/client-petrosea.png": 73,
	"./clients/client1.jpg": 74,
	"./clients/client2.jpg": 75,
	"./clients/client3.jpg": 76,
	"./crane-64.png": 224,
	"./defaultImage.jpeg": 60,
	"./dsk-about-bg.jpg": 225,
	"./dsk-about-bg1.jpg": 226,
	"./dsk-contact-bg.jpg": 227,
	"./dsk-contact-bg1.jpg": 228,
	"./dsk-fact.jpg": 229,
	"./dsk-home-bg.jpg": 230,
	"./dsk-home-bg1.jpg": 231,
	"./dsk-products-bg.jpg": 232,
	"./dsk-projects-bg.jpg": 233,
	"./dsk-projects-bg1.jpg": 234,
	"./dsk-service-bg.jpg": 235,
	"./dsk-service-bg1.jpg": 236,
	"./dsk.jpg": 54,
	"./fb.png": 55,
	"./fonts/GourmetHearth.otf": 237,
	"./formBg.jpg": 238,
	"./hammer256.png": 114,
	"./logo.png": 59,
	"./nail-64.png": 239,
	"./products/Bahu shoulder 15 cm & 35 cm DSK.jpg": 77,
	"./products/Cat walk 120 dsk.jpg": 78,
	"./products/Horizontal Frame 1,2m.jpg": 79,
	"./products/Horizontal shore 0,9 meter.jpg": 80,
	"./products/Horizontal shore 1,2 meter & 0,9 meter - Salin.jpg": 81,
	"./products/Horizontal shore 1,2 meter.jpg": 82,
	"./products/Jack base 60cm solid.jpg": 83,
	"./products/Kuncian siku tembereng (tie rod 50cm).jpg": 84,
	"./products/Main beam (hollow 50x50) 2,4m,,3.0m,,4.0m.jpg": 85,
	"./products/Main beam 2,4m (Hollow 50x50 x2,4m).jpg": 86,
	"./products/Main beam 3.0m (hollow 50x50 x3.0m).jpg": 87,
	"./products/Main beam 4.0m (hollow 50x50x4.0m).jpg": 88,
	"./products/Metal Plank 250mm X 2,5m.jpg": 89,
	"./products/Pipa 40 cm joint sock 20cm.jpg": 90,
	"./products/Pipa 40cm polos & pipa 40cm joint sock 20cm.jpg": 91,
	"./products/Pipa 40cm polos.jpg": 92,
	"./products/Post shore 1,2,3 meter.jpg": 93,
	"./products/Post shore 1.0 meter.jpg": 94,
	"./products/Post shore 2.0 meter.jpg": 95,
	"./products/Post shore 3.0 meter.jpg": 96,
	"./products/Push pull 3.0m tampak samping.jpg": 97,
	"./products/Push pull 3.0m.jpg": 98,
	"./products/Siku tembereng 30-50.jpg": 99,
	"./products/Sub beam 2,4m (hollow 40x40x2,4m).jpg": 100,
	"./products/Sub beam 3.0m (hollow 40x40x3.0m).jpg": 101,
	"./products/Sub beam 4,8m (hollow 40x40x4,8m).jpg": 102,
	"./products/Sub beam 4,8m,,3.0m,,2,4m (hollow 40x40).jpg": 103,
	"./products/Suri-suri 170cm tampak samping.jpg": 104,
	"./products/Suri-suri 170cm.jpg": 105,
	"./products/Swipel Clamp (Hidup).jpg": 106,
	"./products/Tangga DSK Versi 2.jpg": 107,
	"./products/Tangga DSK tampak samping.jpg": 108,
	"./products/Tangga dsk.jpg": 109,
	"./products/U- head 60cm hollow DSK.jpg": 110,
	"./products/U-head 60cm solid.jpg": 111,
	"./products/Whell 8 inch (Roda Scaffolding 8 x 2).jpg": 112,
	"./projects/p1.jpg": 61,
	"./projects/p10.jpg": 62,
	"./projects/p2.jpg": 63,
	"./projects/p3.png": 64,
	"./projects/p4.png": 65,
	"./projects/p5.jpg": 66,
	"./projects/p6.jpg": 67,
	"./projects/p7.jpg": 68,
	"./projects/p8.jpg": 69,
	"./projects/p9.jpg": 70,
	"./repair-64.png": 240,
	"./scaff-64.jpg": 241,
	"./scaffolding-64.png": 242,
	"./sketch-64.png": 243,
	"./sketch256.png": 115,
	"./spinner.gif": 180,
	"./twitter.png": 56,
	"./why-us.png": 116,
	"./why-us1.jpg": 244
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 222;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = 222
// module chunks = 1